import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const photoVignetteService = {
  async post(categoryId: number, json: any): Promise<any> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const formData = new FormData();
      formData.append('image', json);
      const { data } = await axiosAjax.post(
        process.env.API_PHOTO_VIGNETTE
          .replace(':categoryId', '' + categoryId),
        formData,
        config
      );
      if (data.error) {
        throw new Error();
      }
      return data.data;
      } catch (e) {
        throw new Error(e);
      }
  }
}
